import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useAssigneeWorkload } from '../../hooks/useDashboard';
import Spinner from '../ui/Spinner';

const PALETTE = ['#3B82F6', '#10B981', '#8B5CF6', '#F97316', '#EF4444', '#6B7280', '#059669', '#D97706'];

interface Props {
  projectId: string;
}

export default function AssigneeWorkloadWidget({ projectId }: Props) {
  const { data, isLoading } = useAssigneeWorkload(projectId);

  if (isLoading) {
    return <div className="flex items-center justify-center h-full"><Spinner className="size-6" /></div>;
  }

  if (!data || data.length === 0) {
    return (
      <div className="h-full flex flex-col">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">담당자별 작업 현황</h3>
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">데이터 없음</div>
      </div>
    );
  }

  // 모든 status 키 수집
  const allStatuses = [...new Set(data.flatMap((d) => Object.keys(d.statuses)))];

  const chartData = data.map((d) => ({
    name: d.assigneeName,
    ...d.statuses,
  }));

  return (
    <div className="h-full flex flex-col">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">담당자별 작업 현황</h3>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <XAxis dataKey="name" tick={{ fontSize: 11 }} stroke="#9CA3AF" />
          <YAxis tick={{ fontSize: 11 }} stroke="#9CA3AF" allowDecimals={false} />
          <Tooltip
            contentStyle={{ fontSize: 12, borderRadius: 8 }}
            formatter={(value, name) => [
              `${value}건`,
              name as string,
            ]}
          />
          <Legend
            formatter={(value: string) => (
              <span className="text-sm">{value}</span>
            )}
          />
          {allStatuses.map((status, index) => (
            <Bar
              key={status}
              dataKey={status}
              stackId="a"
              fill={PALETTE[index % PALETTE.length]}
              maxBarSize={40}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
